export enum TermsFormLinkedField {
    CashAtCloser = 0,
    NetCashAtCloser = 1,
    DeferredFixedPayments = 2,
    DeferredVariablePayments = 3,
    JvEquity = 4,
    CorporateEquity = 5,
    Other = 6,
    PracticePropertyPurchased = 7,
    PracticeRealPropertyIncluded = 8,
}

export const TermsFormLinkedFieldLabels: Record<TermsFormLinkedField, string> = {
    [TermsFormLinkedField.CashAtCloser]: 'Cash at Closer',
    [TermsFormLinkedField.NetCashAtCloser]: 'Net Cash at Closer',
    [TermsFormLinkedField.DeferredFixedPayments]: 'Deferred Fixed Payments',
    [TermsFormLinkedField.DeferredVariablePayments]: 'Deferred Variable Payments',
    [TermsFormLinkedField.JvEquity]: 'JV Equity',
    [TermsFormLinkedField.CorporateEquity]: 'Corporate Equity',
    [TermsFormLinkedField.Other]: 'Other',
    [TermsFormLinkedField.PracticePropertyPurchased]: 'Practice Property Purchased',
    [TermsFormLinkedField.PracticeRealPropertyIncluded]: 'Practice Real Property Included',
};

export const TermsFormLinkedFieldOptions: { value: TermsFormLinkedField; label: string }[] = [
    { value: TermsFormLinkedField.CashAtCloser, label: TermsFormLinkedFieldLabels[TermsFormLinkedField.CashAtCloser] },
    { value: TermsFormLinkedField.NetCashAtCloser, label: TermsFormLinkedFieldLabels[TermsFormLinkedField.NetCashAtCloser] },
    { value: TermsFormLinkedField.DeferredFixedPayments, label: TermsFormLinkedFieldLabels[TermsFormLinkedField.DeferredFixedPayments] },
    { value: TermsFormLinkedField.DeferredVariablePayments, label: TermsFormLinkedFieldLabels[TermsFormLinkedField.DeferredVariablePayments] },
    { value: TermsFormLinkedField.JvEquity, label: TermsFormLinkedFieldLabels[TermsFormLinkedField.JvEquity] },
    { value: TermsFormLinkedField.CorporateEquity, label: TermsFormLinkedFieldLabels[TermsFormLinkedField.CorporateEquity] },
    { value: TermsFormLinkedField.Other, label: TermsFormLinkedFieldLabels[TermsFormLinkedField.Other] },
    { value: TermsFormLinkedField.PracticePropertyPurchased, label: TermsFormLinkedFieldLabels[TermsFormLinkedField.PracticePropertyPurchased] },
    { value: TermsFormLinkedField.PracticeRealPropertyIncluded, label: TermsFormLinkedFieldLabels[TermsFormLinkedField.PracticeRealPropertyIncluded] },
];
